/** @module Merchandising/DeleteVersionController */
define([
	"dojo/_base/declare",
	"csi/table/Delete",
	"csi/session",
	"csi/state/rootStore"
], function(declare,DeleteController,session, { sessionStore }) {

	return declare(DeleteController, {

		/*
		*@override
		*/
		postProcessSuccess: function() {
			// summary: navigate to parent node
			if (sessionStore.locationUrl === this.m_urlNode) {
				session.setLocationUrl(this.getParentURL(), true);
			} else {
				return this.inherited(arguments);
			}
		}
	});
});